import React from "react";

import type { TModalProps } from "../types";
import { ModalLayout } from "./ModalLayout";
import { ModalOverlay } from "./ModalOverlay";

export const Modal = ({
  isOpen,
  closeOnClickOutside = false,
  isMobile,
  isFadeBackground = false,
  customCssProperties,
  arrowCssProperties,
  ...props
}: TModalProps) => {
  return (
    <ModalOverlay
      isOpen={isOpen}
      onClose={props.onClose}
      closeOnClickOutside={closeOnClickOutside}
      isMobile={isMobile}
      isFadeBackground={isFadeBackground}
      customCssProperties={customCssProperties}
      arrowCssProperties={arrowCssProperties}
    >
      <ModalLayout {...props} />
    </ModalOverlay>
  );
};
export default Modal;
